import { Input, Output } from '@angular/core';
import { Component, OnInit, EventEmitter } from '@angular/core';
import { Subscription, timer } from 'rxjs';


@Component({
  selector: 'wpro-success-notification',
  templateUrl: './success-notification.component.html',
  standalone: false
})
export class SuccessNotificationComponent implements OnInit {
  public timerSource: Subscription;
  @Output() hideSuccessNotificationPopup = new EventEmitter<boolean>();
  @Input() messageFlag: string;
  constructor() { }

  ngOnInit(): void {
    this.startTimer();
  }
  startTimer(): void {
    const TIMER = 3000;
    const source = timer(TIMER);  // 3 seconds
    this.timerSource = source.subscribe(() => {
      this.hideSuccessNotificationPopup.emit(false);
      this.stopTimer();
    });
  }
  stopTimer(): void {
    if (!this.timerSource.closed) {
      this.timerSource.unsubscribe();
    }
  }
  closeToast(): void {
    this.hideSuccessNotificationPopup.emit(false);
  }
}
